const isProd: boolean = (process.env.REACT_APP_ENV || '').toLowerCase() === 'production';
const isStg: boolean = (process.env.REACT_APP_ENV || '').toLowerCase() === 'stage';
const appUrl: string = process.env.REACT_APP_URL || '';
const baseUrl: string = process.env.REACT_APP_API_URL || '';
const baseDigitalPaymentsUrl: string = process.env.REACT_APP_DIGITAL_PAYMENTS_API_URL || '';
const cookieName: string = process.env.REACT_APP_COOKIE_NAME || '';
const oytserLanding: string = process.env.REACT_APP_LANDING || '';
const paymentsLanding: string = process.env.REACT_APP_PAYMENTS_LANDING || '';
const oysterPayUrl: string = process.env.REACT_APP_OYSTER_PAY_URL || '/pay';
const termsLink: string = process.env.REACT_APP_OYSTER_TERMS_AND_CONDITIONS_URL || '';
const paymentsInfoLink: string = process.env.REACT_APP_OYSTER_CASH_PAYMENTS_INFO || '';
const privacyLink: string = process.env.REACT_APP_OYSTER_PRIVACY_URL || '';
const gtmId: string = process.env.REACT_APP_GTM_ID || '';
const gaTrackingId: string = process.env.REACT_APP_GA_TRACKING_ID || '';
const kushkiIdentification: string =
  process.env.REACT_APP_KUSHKI_IDENTIFICATION_COOKIE_NAME || 'kushkiIdentification';
const baseRedPayUrl: string = process.env.REACT_APP_REDPAY_API_URL || '';
const basePorCobrarUrl: string = process.env.REACT_APP_API_URL_PC || '';
const authTokenPorCobrar: string = process.env.REACT_APP_TOKEN_PC || '';
const porCobrarSuraAppUrl: string = process.env.REACT_APP_PC_SURA_APP || '';

export {
  isProd,
  isStg,
  appUrl,
  baseUrl,
  cookieName,
  oytserLanding,
  paymentsLanding,
  oysterPayUrl,
  termsLink,
  paymentsInfoLink,
  privacyLink,
  gtmId,
  gaTrackingId,
  kushkiIdentification,
  baseDigitalPaymentsUrl,
  baseRedPayUrl,
  basePorCobrarUrl,
  authTokenPorCobrar,
  porCobrarSuraAppUrl,
};
